import React from "react";
import { SVG } from "~components";
import cn from "classnames";
import * as styles from "./styles.module.scss";

const Review = ({ title, stars, name, date, text }) => {
  /** ============================================================================
   * @component
   * A user review
   *
   * @param 	{string}  			title			 	Title of review
   * @param 	{number}  			stars			 	Number of stars, out of 5
   * @param 	{string}  			name			 	The reviewer's name
   * @param 	{string}  			date			 	The date the review was left, formatted `DD.MM.YYYY`
   * @param 	{string}  			text 				The review text
   * @return	{node}
   */

  const MAX_STARS = 5;
  const starsAwarded = Math.min(MAX_STARS, stars);
  const filledStarArray = [...Array(starsAwarded || 0).keys()];
  const unfilledStarArray = [...Array(5 - starsAwarded || 0).keys()];

  return (
    <div className={styles.container}>
      <div className={cn(`h4`, styles.title)}>{title}</div>
      <div className={styles.info}>
        <div className={styles.stars}>
          {filledStarArray.map((i) => (
            <SVG svg="starFilled" className={styles.star} key={i} />
          ))}
          {unfilledStarArray.map((i) => (
            <SVG svg="star" className={styles.star} key={i} />
          ))}
        </div>
        <span className="b2">
          {name}
          {date && `, ${date}`}
        </span>
      </div>
      <p className="b1">{text}</p>
    </div>
  );
};

export default Review;
